// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoPlayerVolume__container-cb1de4 {
  align-items: center;
  display: flex;
  padding: 8px;
}

.VideoPlayerVolume__action-button-cbd7ad {
  color: var(--addition-50);
}

.VideoPlayerVolume__action-button-cbd7ad:focus-visible {
  color: var(--ib-color-hover); /* TODO: change design */
}

.VideoPlayerVolume__volume-b1d875 {
  cursor: pointer;
  position: relative;
  height: 6px;
  width: 0;
  overflow: hidden;
  --volume-border-radius: 6px;
}

.VideoPlayerVolume__container-cb1de4:hover .VideoPlayerVolume__volume-b1d875,
.VideoPlayerVolume__volume-b1d875.VideoPlayerVolume__active-ffcf05,
.VideoPlayerVolume__volume-b1d875:focus {
  width: 86px;
  overflow: initial;
  margin-inline-start: 10px;
}

.VideoPlayerVolume__volume-b1d875:focus-visible {
  box-shadow: 0 0 0 1px var(--info-30);
}

.VideoPlayerVolume__volume-background-ad23b1 {
  background-color: var(--addition-50_40);
  border-radius: var(--volume-border-radius);
  height: 100%;
}

.VideoPlayerVolume__volume-bar-d94bda {
  background-color: var(--addition-50);
  border-radius: var(--volume-border-radius);
  position: absolute;
  top: 0;
  width: 10%;
  height: 100%;
}

.VideoPlayerVolume__volume-pin-c0e6af {
  background-color: var(--addition-50);
  border-radius: 50%;
  height: 16px;
  width: 16px;
  position: absolute;
  top: -5px;
  margin-inline-start: -8px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/VideoPlayer/VideoPlayerVolume/VideoPlayerVolume.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,4BAAA,EAAA,wBAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;EAEA,2BAAA;AAAF;;AAGA;;;EAGE,WAAA;EACA,iBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,uCAAA;EACA,0CAAA;EACA,YAAA;AAAF;;AAGA;EACE,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;AAAF;;AAGA;EACE,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;AAAF","sourcesContent":[".container {\n  align-items: center;\n  display: flex;\n  padding: 8px;\n}\n\n.action-button {\n  color: var(--addition-50);\n}\n\n.action-button:focus-visible {\n  color: var(--ib-color-hover); /* TODO: change design */\n}\n\n.volume {\n  cursor: pointer;\n  position: relative;\n  height: 6px;\n  width: 0;\n  overflow: hidden;\n\n  --volume-border-radius: 6px;\n}\n\n.container:hover .volume,\n.volume.active,\n.volume:focus {\n  width: 86px;\n  overflow: initial;\n  margin-inline-start: 10px;\n}\n\n.volume:focus-visible {\n  box-shadow: 0 0 0 1px var(--info-30);\n}\n\n.volume-background {\n  background-color: var(--addition-50_40);\n  border-radius: var(--volume-border-radius);\n  height: 100%;\n}\n\n.volume-bar {\n  background-color: var(--addition-50);\n  border-radius: var(--volume-border-radius);\n  position: absolute;\n  top: 0;\n  width: 10%;\n  height: 100%;\n}\n\n.volume-pin {\n  background-color: var(--addition-50);\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  top: -5px;\n  margin-inline-start: -8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VideoPlayerVolume__container-cb1de4`,
	"action-button": `VideoPlayerVolume__action-button-cbd7ad`,
	"actionButton": `VideoPlayerVolume__action-button-cbd7ad`,
	"volume": `VideoPlayerVolume__volume-b1d875`,
	"active": `VideoPlayerVolume__active-ffcf05`,
	"volume-background": `VideoPlayerVolume__volume-background-ad23b1`,
	"volumeBackground": `VideoPlayerVolume__volume-background-ad23b1`,
	"volume-bar": `VideoPlayerVolume__volume-bar-d94bda`,
	"volumeBar": `VideoPlayerVolume__volume-bar-d94bda`,
	"volume-pin": `VideoPlayerVolume__volume-pin-c0e6af`,
	"volumePin": `VideoPlayerVolume__volume-pin-c0e6af`
};
module.exports = ___CSS_LOADER_EXPORT___;
